<template>
	<div class="manual-mode">
		<MultipleSelectSettingsEditor
			:options="dropdownOptions"
			:isOptionValue="isOptionValue"
			keyPlaceholder="Enter dropdown option..."
			valuePlaceholder="Enter dropdown value..."
			:noSuffix="noSuffix"
			@onChange="onChange"
		/>
	</div>
</template>

<script>
import MultipleSelectSettingsEditor from '../FieldOptions/MultipleSelectSettingsEditor/MultipleSelectSettingsEditor';

export default {
	name: 'DropdownManualOptionsSettings',
	components: {
		MultipleSelectSettingsEditor,
	},
	props: {
		noSuffix: { type: Boolean },
		localField: { type: Object },
	},
	computed: {
		dropdownOptions: {
			get() {
				return this.localField.metadata.options.dropdown_options || [];
			},
			set(value) {
				this.$emit('updateLocalField', { key: 'metadata.options.dropdown_options', value });
			},
		},
		isOptionValue() {
			return this.localField.metadata.options?.option_value?.enabled;
		},
	},
	methods: {
		onChange(result) {
			this.dropdownOptions = result;
		},
	},
};
</script>

<style scoped lang="scss"></style>
